import {
    ICurrencyData,
    IPricePayload,
    IListResponse
} from '../../entities'
import {
    ICurrencyService
} from './index'
import {
    AxiosInstance,
    AxiosResponse
} from 'axios'
import {
    defaultConfig
} from '../config'


export class CurrencyService implements ICurrencyService {
    constructor(private readonly axios: AxiosInstance) {}

    async getAll(language?: string): Promise<AxiosResponse<IListResponse<ICurrencyData[]>>> {
        return this.axios.get('', defaultConfig(language))
    }

    async getPrice(payload: IPricePayload, language?: string): Promise<AxiosResponse<IListResponse<number>>> {
        return this.axios.get(`/${ payload.id }`, {
            ...defaultConfig(language),
            params: {
                value: payload.value
            }
        })
    }

}
